import React from "react";
import MissionVision from "../about-us-components/MissionVision";
import WhatDrivesUs from "../about-us-components/WhatDrivesUs";
import NumbersThatMatterSection from "../about-us-components/NumbersThatMatterSection";
import OurStory from "../about-us-components/OurStory";

function AboutUs() {
  return (
    <div>
      <OurStory />
      <MissionVision />
      <WhatDrivesUs />
      <NumbersThatMatterSection />
    </div>
  );
}

export default AboutUs;
